<template>
    <div class="about">
        <div class="pg-header">
            <div>
                <label class="title">推送日志</label>
            </div>
            <div class="algr">
                <div class="pg-nav">
                    <i class="icon-home"></i>
                    <span>系统管理</span>|
                    <span class="active">推送日志</span>
                </div>
            </div>
        </div>
        <div class="collapse-wrap">
            <div class="search-bar">
                <el-form ref="form" label-width="120px">
                    <div class="def-key">

                        <label>姓名
                            <el-input size="small" style="width:96px" placeholder="" clearable v-model="filter.name"
                                @change="handleFilter(1, $event)"></el-input>
                        </label>
                        <label>就诊号
                            <el-input size="small" style="width:96px" placeholder="" clearable v-model="filter.visitNo"
                                @change="handleFilter(1, $event)"></el-input>
                        </label>
                        <div>科室
                            <el-select size="small" filterable clearable placeholder="请选择" v-model="filter.depId"
                                @change="handleFilter(1, $event)">
                                <el-option v-for="item in deptList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </div>

                    <div class="def-key">
                        <div style="display: inline-block;">推送类型
                            <el-select size="small" filterable clearable v-model="filter.pushType" placeholder="请选择"
                                @change="handleFilter(1, $event)">
                                <el-option v-for="item in typeList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <label>推送时间
                            <el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date"
								:picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
                        </label>
                        <div style="display: inline-block;">状态
                            <el-select size="small" filterable clearable v-model="filter.pushState" placeholder="请选择"
                                @change="handleFilter(1, $event)">
                                <el-option v-for="item in stateList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
                    </div>
                </el-form>
            </div>

            <div class="table-wrap">
                <el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
                    :data="list.data" v-loading="isLoading" @selection-change="selectionChange">

                    <el-table-column prop="name" label="姓名" width="100" fixed="left">
                        <template slot-scope="scope">
                            <span class="fc key" @click="toDetail(scope.row)">
                                {{ scope.row.name }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="visitNo" label="就诊号" width="110"></el-table-column>
                    <el-table-column prop="depName" label="科室" width="110"></el-table-column>
                    <el-table-column label="推送类型" width="160">
                        <template slot-scope="scope">
                            {{ getTypeList(scope.row.pushType) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="lastPushTime" label="推送时间" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态" width="120">
                        <template slot-scope="scope">
                            <el-tag :type="getPushState(scope.row.pushState).type">{{ getPushState(scope.row.pushState).name
                            }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="errorJson" label="失败原因" show-overflow-tooltip></el-table-column>

                    <el-table-column label="操作" width="120">
                        <template slot-scope="scope">
                            <el-tooltip content="查看" placement="top" :enterable="false">
                                <i class="icon-research" @click="toDetail(scope.row)"></i>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-row>
                        <el-col :span="12">
                            <div class="record">当前是第<span
                                    v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
                                    v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
                            </div>
                            <div class="record">总计<span v-text="list.total"></span>条记录</div>
                        </el-col>
                        <el-col :span="12" style="text-align: right;">
                            <el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
                                :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
                                :current-page="list.current" :page-size="filter.pageSize" :total="list.total"
                                @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                        </el-col>
                    </el-row>
                </div>
            </div>

        </div>

    </div>
</template>
  
<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';

export default {
    mixins: [mixin],
    data() {
        return {
            list: {
                current: 1,
                total: 0,
                pageSize: 0,
                data: null,
                summary: []
            },
            filter: {
                depId: '',
                lastPushTimeStart: '',
                lastPushTimeEnd: '',
                pageNumber: 1,
                pageSize: 10,
                pushState: '',
                pushType: '',
                name: '',
                visitNo: '',
                date:[]

            },

            typeList: [
                // { id: 0, name: '评估' },
                { id: 1, name: '用药处方' },
                { id: 2, name: '饮食处方' },
                { id: 3, name: '运动处方' },
                { id: 4, name: '心理处方' },
                { id: 5, name: '睡眠处方' },
                { id: 6, name: '中医处方' },
                { id: 7, name: '随访推送' },
                { id: 8, name: '复诊提醒' }
            ],
            stateList: [
                { id: 1, name: '成功', type: 'success' },
                { id: 2, name: '失败', type: 'danger' },
                { id: 3, name: '推送中', type: 'warning' }
            ],
            deptList: []
        }
    },
    created() {
        this.loadList();
    },
    mounted() {
        api.getDeptDropdown({}).then((res) => {
            if (res.code == 1000 && res.data) {
                this.deptList = res.data;
            }
        })
    },
    methods: {
        getTypeList(id){
            return this.typeList.find(item => item.id === id).name;

        },
        getPushState(id) {
            return this.stateList.find(item => item.id === id) || {};
        },
        toDetail(item) {
            let query = {}
            // 院中 ： patientid recordId   ：datasource
            // 随访：patientid   followupid  date 
            // 复诊： patientId recordId  datasources
            // 0评估1用药处方2饮食处方3运动处方4心理处方5睡眠处方6中医处方7随访推送8复诊提醒
            switch (item.pushType) {
                case 0:
                    query = { patientId: item.patientId, t: 3, fid: item.recordId, datasources: item.dataSource }
                    break;
                case 1: case 2: case 3: case 4: case 5: case 6:
                    query = { patientId: item.patientId, t: 3, fid: item.recordId, datasources: item.dataSource , t2: 4,p: item.pushType }
                    break;
                case 7:
                    query = { patientId: item.patientId, t: 5, date: dayjs(item.followupDate).format('YYYY-MM-DD'), followupId: item.followupId }
                    break;
                case 8:
                    query = { patientId: item.patientId, t: 3, fid: item.recordId, datasources: item.dataSource, t2: 3 }
                    break
            }
            const queryString = new URLSearchParams(query).toString();

            window.open(`#/patient/user?${queryString}`, "_blank");
        },
        async loadList() {
            this.isLoading = true;
            let res = await api.getListUniappPush(this.filter);
            if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }
            console.log(res)
            this.list.total = +res.total;
            this.list.current = this.filter.pageNumber;
            this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
            this.list.data = res.data;
            this.isLoading = false;
        },
        // 过滤条件 更改
        handleFilter(key, val) {
            switch (key) {
                case 0:
                    if (this.filter.date) {
                        this.filter.lastPushTimeStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD');
                        this.filter.lastPushTimeEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD');

                    } else {
                        this.filter.lastPushTimeStart = '';
                        this.filter.lastPushTimeEnd = '';

                    }
                    break;
            }
            this.filter.pageNumber = 1;
            this.loadList();
        },
        handleSizeChange(v) {
            this.filter.pageSize = v;
            this.filter.pageNumber = 1;
            this.loadList();
        },
        handleCurrentChange(v) {
            this.filter.pageNumber = v;
            this.loadList();
        },
    }
}
</script>
          
<style lang="less" scoped>
@import '@/assets/style/var';

/deep/.search-bar .el-select .el-input {
    width: 160px
}

/deep/.el-form .el-input {
    width: 180px
}

/deep/.el-date-editor {
    .el-input__prefix {
        left: 12px;
    }

    .el-input__inner {
        padding: 0 30px 0 40px;
    }
}
</style>
          
  